import IconsEnum from "../../classes/enums/IconsEnum";
import {
  generateCirclePath,
  generateSquarePath,
  isPointNearPath,
} from "../../modules/patients/components/painAssessment/pain-assesment.utils";

export const DRAWING_TOOL_TYPES = {
  PENCIL: "pencil",
  BRUSH: "brush",
  ERASER: "eraser",
  CIRCLE: "circle",
  SQUARE: "square",
};

export const TOOL_CONFIG = {
  [DRAWING_TOOL_TYPES.PENCIL]: {
    id: "pencil",
    name: "Pencil",
    icon: IconsEnum.PEN,
    cursor: "crosshair",
    strokeWidth: 3,

    onStart: ({ pos }) => [pos],

    onMove: ({ pos, currentPath }) => [...currentPath, pos],

    onEnd: ({ currentPath }) => currentPath,

    preview: ({ currentPath }) => currentPath,
  },

  [DRAWING_TOOL_TYPES.BRUSH]: {
    id: "brush",
    name: "Brush",
    icon: IconsEnum.BRUSH,
    cursor: "crosshair",
    strokeWidth: 20,

    onStart: ({ pos }) => [pos],

    onMove: ({ pos, currentPath }) => [...currentPath, pos],

    onEnd: ({ currentPath }) => currentPath,

    preview: ({ currentPath }) => currentPath,
  },

  [DRAWING_TOOL_TYPES.ERASER]: {
    id: "eraser",
    name: "Eraser",
    icon: IconsEnum.ERASER,
    cursor: "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"none\" stroke=\"white\" stroke-width=\"2\"/><circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"none\" stroke=\"black\" stroke-width=\"1\"/></svg>') 12 12, auto",
    strokeWidth: 12,

    onStart: ({ pos }) => [pos],

    onMove: ({ pos, currentPath }) => [...currentPath, pos],

    onEnd: ({ currentPath, allPaths, currentIndex, getPathsToDelete }) => ({
      delete: getPathsToDelete(currentPath, allPaths, currentIndex),
    }),

    preview: () => [], // eraser has no preview line
  },

  [DRAWING_TOOL_TYPES.CIRCLE]: {
    id: "circle",
    name: "Circle",
    icon: IconsEnum.CIRCLE,
    cursor: "crosshair",
    strokeWidth: 3,

    onStart: ({ pos }) => [pos],

    onMove: ({ startPoint, pos }) => [startPoint, pos],

    onEnd: ({ startPoint, currentPath }) => {
      const endPoint = currentPath[currentPath.length - 1];
      return generateCirclePath(startPoint, endPoint);
    },

    preview: ({ startPoint, currentPath }) => {
      const end = currentPath[currentPath.length - 1];
      return generateCirclePath(startPoint, end);
    },
  },

  [DRAWING_TOOL_TYPES.SQUARE]: {
    id: "square",
    name: "Square",
    icon: IconsEnum.SQUARE,
    cursor: "crosshair",
    strokeWidth: 3,

    onStart: ({ pos }) => [pos],

    onMove: ({ startPoint, pos }) => [startPoint, pos],

    onEnd: ({ startPoint, currentPath }) => {
      const endPoint = currentPath[currentPath.length - 1];
      return generateSquarePath(startPoint, endPoint);
    },

    preview: ({ startPoint, currentPath }) => {
      const end = currentPath[currentPath.length - 1];
      return generateSquarePath(startPoint, end);
    },
  },
};

export const getPathsToDelete = (
  eraserPath,
  allPaths,
  orientationIndex,
  radius = 12
) => {
  return allPaths
    .map((p, i) => ({ p, i }))
    .filter(({ p }) => p.orientation === orientationIndex)
    .filter(({ p }) =>
      eraserPath.some((point) => isPointNearPath(point, p.path, radius))
    )
    .map(({ i }) => i);
};

export const DEFAULT_TOOL = DRAWING_TOOL_TYPES.PENCIL;
export const getToolConfig = (id) =>
  TOOL_CONFIG[id] || TOOL_CONFIG[DEFAULT_TOOL];
export const getAllTools = () => Object.values(TOOL_CONFIG);
